import { InitialStateType, AppActions } from "./types.d";
import { updateErrorData, resetErrorData } from "./actions";

const InitialState: InitialStateType = {
  message: "",
  status: "",
  type: ""
};

function reducer(state = InitialState, action: AppActions) {
  switch (action.type) {
    case updateErrorData.TRIGGER:
      return {
        ...state,
        message: action.payload.message,
        status: action.payload.status,
        type: action.payload.type
      };
    case resetErrorData.TRIGGER:
      return {
        ...state,
        message: "",
        status: "",
        type: ""
      };
    default:
      return state;
  }
}

export default reducer;
